import $ from 'jquery';
import 'slick-carousel';

const sliderSingleProductGallery = () => {
	const init = () => {
		exec();
	};

	const exec = () => {
		const el = {
			parent: '.js-single-product-gallery',
			target: '.js-single-product-gallery .woocommerce-product-gallery .flex-control-nav',
		};

		if ($(el.parent).length === 0) return;

		$(document).ready(function () {
			$(el.target).slick({
				dots: false,
				infinite: false,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipe: true,
				prevArrow: `<div class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M8.3335 5L12.7442 9.41074C13.0697 9.73618 13.0697 10.2638 12.7442 10.5893L8.3335 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        </svg></button>`,
				nextArrow: `<div class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M8.3335 5L12.7442 9.41074C13.0697 9.73618 13.0697 10.2638 12.7442 10.5893L8.3335 15" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        </svg></button>`,
			});
		});
	};

	init();
};

try {
	sliderSingleProductGallery();
} catch (e) {
	console.error(e);
}
